// FAT-11: estágio da estratégia (pesquisa → candidata → liberada) e o motivo, derivados no backend a partir do
// backtest persistido. Só "liberada" gera entrada automática na carteira teórica. Estados: vazio (sem backtest),
// indisponível (resposta sem estágio) e completo. Os critérios chegam já descritos em texto: nenhum número vira 0,00%.
import React from 'react';
import './EstatisticasHonestas.css';
import './EstagioEstrategia.css';

const AVISO = 'Resultado passado não garante resultado futuro. O FatCat não executa ordens.';

const ROTULOS = {
  pesquisa: 'Pesquisa',
  candidata: 'Candidata',
  liberada: 'Liberada',
};

const EXPLICACAO = {
  pesquisa: 'Sem evidência fora da amostra mínima: não gera entrada automática.',
  candidata: 'Tem evidência fora da amostra, mas ainda não atende todos os critérios: não gera entrada automática.',
  liberada: 'Atende os critérios: pode gerar entrada automática na carteira teórica, se a saúde da estratégia também permitir.',
};

const CRITERIOS = {
  foraDaAmostra: 'Fora da amostra',
  amostra: 'Amostra',
  psr: 'PSR',
  custos: 'Custos',
  drawdown: 'Drawdown',
};

export default function EstagioEstrategia({ backtest, testId = 'estagio-estrategia' }) {
  if (!backtest) {
    return (
      <section className="eh-panel eh-empty" data-testid={`${testId}-vazio`}>
        <h4>Estágio da estratégia</h4>
        <p>
          <span className="ee-badge ee-pesquisa">Pesquisa</span> Sem backtest persistido: execute o job de backtests.
        </p>
      </section>
    );
  }
  const estagio = ROTULOS[backtest.estagio] ? backtest.estagio : null;
  if (!estagio) {
    return (
      <section className="eh-panel eh-empty" data-testid={`${testId}-indisponivel`}>
        <h4>Estágio da estratégia</h4>
        <p>Estágio indisponível: sem entrada automática até o backend classificar o backtest.</p>
      </section>
    );
  }
  const criterios = Array.isArray(backtest.criteriosEstagio) ? backtest.criteriosEstagio : [];
  return (
    <section className="eh-panel" data-testid={testId}>
      <h4>
        Estágio da estratégia{' '}
        <span className={`ee-badge ee-${estagio}`} data-testid={`${testId}-badge`}>{ROTULOS[estagio]}</span>
      </h4>
      <p className="ee-motivo" data-testid={`${testId}-motivo`}>{backtest.motivoEstagio || EXPLICACAO[estagio]}</p>
      {criterios.length > 0 && (
        <ul className="ee-criterios">
          {criterios.map(c => (
            <li key={c.id} className={c.atendido ? 'ee-ok' : 'ee-falha'}>
              <span aria-hidden="true">{c.atendido ? '✓' : '✗'}</span>{' '}
              <span className="eh-label">{CRITERIOS[c.id] || c.id}:</span> {c.descricao || 'indisponível'}
            </li>
          ))}
        </ul>
      )}
      <p className="eh-help">{EXPLICACAO[estagio]}</p>
      <p className="eh-disclaimer">{AVISO}</p>
    </section>
  );
}
